const styles = {
  buttonLogout: {
    fontFamily: "Roboto",
    fontSize: "14px",
    lineHeight: "18px",
    color: "#06844D",
    border: "0",
    padding: "0",
    backgroundColor: "transparent",
    marginLeft: "20px",
  },
}

export default styles;
